import allCountries from './raws/allCountries.json'
import emojiFlags from 'country-currency-emoji-flags'

class Countries {
  static anyCountyPlaceHolder() {
    return {
      countryCode: '',
      countryCodeLowerCase: '',
      countryName: 'Tous les pays',
      callingCode: 0,
      countryFlag: '🏳️',
      region: '',
      depositSupported: false,
      chooseAsDepositCountry: false,
      currency: '',
    }
  }
  static find(countryCode = '') {
    return countriesJson[countryCode.toUpperCase()] || null
  }
  static get(depositPossibleCountries = false, depositSupportedOnly = false) {
    let countries = countriesArray
    if (depositPossibleCountries)
      countries = countries.filter(country => {
        return country.chooseAsDepositCountry
      })
    if (depositSupportedOnly)
      countries = countries.filter(country => {
        return country.depositSupported
      })
    return countries
  }
  static getByCountryCode(countryCodes) {
    let countries = countryCodes.map(countryCode => {
      return countriesJson[countryCode]
    })
    return countries
  }
  static getPhoneCountry(phoneNumber) {
    if (!phoneNumber) return null
    let callingCode = phoneNumber.replace(/^(...).+$/, '$1')
    let country = Countries.get().find(
      countryTested => countryTested.callingCode == callingCode,
    )
    if (!country) {
      callingCode = phoneNumber.replace(/^(..).+$/, '$1')
      country = Countries.get().find(
        countryTested => countryTested.callingCode == callingCode,
      )
    }
    return country
  }

  static getCountryFlag(countryCode) {
    const flag = emojiFlags.getEmojiByCountryCode(countryCode)
    return flag || '🏳️'
  }

  static getSignupCountries() {
    return Countries.getByCountryCode(signupCountries)
  }

  static getEcowasCountries() {
    return Countries.getByCountryCode(signupCountries)
  }
}

const signupCountries = 'BJ,BF,CI,ML,SN,TG'.split(',')

// const signupCountries = 'BJ,BF,CI,NE,ML,GA,SN,GW,GH,CM,NG,CF,CD,CG,TD,TG'.split(
//   ',',
// )

function getCountriesArray() {
  return Object.values(countriesJson)
}

function getCountriesJson() {
  const countriesAsJson = {}

  allCountries.forEach(element => {
    const country = {
      countryCode: element.alpha2Code,
      countryCodeLowerCase: element.alpha2Code.toLowerCase(),
      countryName: element.translations.fr,
      callingCode: parseInt(element.callingCodes[0] || '0', 10),
      countryFlag: Countries.getCountryFlag(element.alpha2Code),
      region: element.region,
      depositSupported: false,
      chooseAsDepositCountry: false,
      currency: element.currencies[0].code,
      phonePrefix: element.callingCodes[0],
    }
    countriesAsJson[country.countryCode] = country
  })

  return countriesAsJson
}

const countriesJson = getCountriesJson()
const countriesArray = getCountriesArray()

export { Countries }
